module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Italic.f9c440ab.ttf";